import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-inspections.svg'

const CampaignInspectionsBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Inspections Available</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No campaign inspections to display. Inspections will automatically feed from your CRM if set,
      otherwise you can add an inspection date and time in the campaigns property details page.
      If you&apos;ve filtered the results you may need to remove some filters to see more.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default CampaignInspectionsBlankState
